export enum SignatoryStatus {
    IN_ORDE = 'IN_ORDE',
    NIET_IN_ORDE = 'NIET_IN_ORDE', 
    ONBEKEND = 'ONBEKEND'
}

export class ISignatoryResponse {
  success: boolean;
  signatoryStatus: SignatoryStatus;
}